import React from 'react';
import { Alert } from '@biome-design-system/ui/Alert';
import { Box } from '@biome-design-system/ui/Box';
import { Button } from '@biome-design-system/ui/Button';
import { Chip } from '@biome-design-system/ui/Chip';
import { getOverrides } from '@biome-design-system/hs-utils/utils';
import { FormattedMessage, useIntl } from '@kyruus/intl';
import { PATIENT_RELATIONSHIPS } from '@kyruus/provider-components';

import messages from './messages';

export const AvailabilityControls = ({
  selectedAppointment,
  handleToggle,
  handleEdit
}) => {
  const intl = useIntl();
  const isOn = Boolean(selectedAppointment);

  const actions = isOn ? (
    <Box sx={{ display: 'flex', flexFlow: 'row nowrap', gap: 1 }}>
      <Button
        size="small"
        color="neutral"
        variant="outlined"
        onClick={handleToggle}
        data-testid="AvailabilityControls--toggle"
        aria-label={intl.formatMessage(
          messages.globalAvailClearButtonAriaLabel
        )}
      >
        <FormattedMessage {...messages.globalAvailClearButton} />
      </Button>
      <Button
        size="small"
        color="primary"
        variant="contained"
        onClick={handleEdit}
        data-testid="AvailabilityControls--edit"
        aria-label={intl.formatMessage(messages.globalAvailEditButtonAriaLabel)}
      >
        <FormattedMessage {...messages.globalAvailEditButton} />
      </Button>
    </Box>
  ) : (
    <Button
      size="small"
      color="primary"
      variant="contained"
      onClick={handleToggle}
      data-testid="AvailabilityControls--toggle"
      aria-label={intl.formatMessage(
        messages.gloabalAvailApptTypeButtonAriaLabel
      )}
    >
      <FormattedMessage {...messages.globalAvailApptTypeButton} />
    </Button>
  );

  return (
    <Alert
      icon={false}
      action={actions}
      role="status"
      data-testid="AvailabilityControls"
      elevation={0}
      variant="outlined"
      severity="info"
      sx={{
        display: 'flex',
        flexFlow: 'row wrap',
        gap: '2ch',
        alignItems: 'center',
        '& .MuiAlert-message': {
          display: 'flex',
          flexFlow: 'row wrap',
          gap: 1,
          padding: 0,
          height: '100%',
          alignItems: 'center'
        },
        '& .MuiAlert-message > .MuiBox-root': {
          overflow: 'hidden'
        },
        '& .MuiAlert-action': {
          padding: 0,
          margin: 0,
          flex: '1 0 auto',
          justifyContent: 'flex-end'
        },
        '& .MuiAlert-action .MuiButton-root': {
          borderWidth: 1
        },
        '& .MuiAlert-action .MuiButton-root.MuiButton-contained:not(:disabled, .disabled)':
          (theme) =>
            getOverrides(
              theme.components.MuiButton?.styleOverrides?.contained,
              { theme }
            ),
        '& .MuiAlert-action .MuiButton-root.MuiButton-outlined:not(:disabled, .disabled)':
          (theme) =>
            getOverrides(theme.components.MuiButton?.styleOverrides?.outlined, {
              theme
            })
      }}
    >
      {isOn ? (
        <FormattedMessage {...messages.globalAvailOnLabelText} />
      ) : (
        <FormattedMessage {...messages.globalAvailOffLabelText} />
      )}
      {isOn ? (
        <Box sx={{ display: 'flex', gap: 1, flexFlow: 'row wrap' }}>
          <Chip
            sx={{ borderRadius: (theme) => theme.shape.borderRadius }}
            color="default"
            size="small"
            variant="outlined"
            label={intl.formatMessage(
              selectedAppointment.patientRel === PATIENT_RELATIONSHIPS.NEW
                ? messages.patientRelBtnTextNew
                : messages.patientRelBtnTextEstablished
            )}
            data-testid="AvailabilityControls--patientRel"
          />
          <Chip
            sx={{ borderRadius: (theme) => theme.shape.borderRadius }}
            color="default"
            size="small"
            variant="outlined"
            label={selectedAppointment.purpose}
            data-testid="AvailabilityControls--apptPurpose"
          />
        </Box>
      ) : null}
    </Alert>
  );
};
